import React from 'react';
import { PanelType } from '@fluentui/react';
import { IDictionary } from '@ioip/core/lib/utilities';
import { Grid, StandarPanel } from '@ioip/core/lib/components';
import { CForm } from '../../types';
import { JSEngine } from '../types/JSEngine';
import { UXForm } from './UXForm';
import { useForceUpdate } from '@ioip/core/lib/hooks/useForceState';

export interface IPChildFormComponentProps {
    customComponents?: IDictionary<(props: IDictionary<any>) => JSX.Element>;
    onClose: () => void;
    onAccept: () => void;
    panelTitle: string;
    panelType: PanelType;
    form: CForm;
    sdk: JSEngine;
    show: boolean;
}

export const UXChildForm = (props: IPChildFormComponentProps): JSX.Element => {

    const forceUpdate = useForceUpdate();

    return <StandarPanel
        isOpen={true}
        type={props.panelType || PanelType.medium}
        headerText={props.panelTitle || ''}
        onAccept={() => {
            if (props.form.validate()) {
                props.onAccept();
                props.onClose();
            } else {
                forceUpdate();
            }
        }}
        hideAcceptButton={props.form.readonly}
        onClose={() => props.onClose()}
    >
        <>
            {props.form == null && <div>
                Cargando...
            </div>}
            <Grid>
                <UXForm
                    form={props.form}
                    showTitle={false}
                    showCommandBar={false}
                    customComponents={props.customComponents}
                    activityInstance={null}
                />
            </Grid>
        </>
    </StandarPanel>
}